export default __webpack_public_path__ + "static/media/cohort-wind.bcbb19d5.svg";